import React from "react";
import settingable from "fantastic/components/hoc/settingable";

const HtmlSettings = () => {
  return null;
};

export default settingable("html", "background", "padding", "visibility")(HtmlSettings);
